import { store } from "@/shared-store";
import {
  IIncodeStatus,
  incodeStatus,
  incodeStatusFront,
  IIncodeImport,
  incodeImport,
} from "@/apps/merchant3/services/incode.service";
import { AxiosError, AxiosResponse } from "axios";
import { onUnmounted } from "vue";
import ActionLogs from "@/apps/merchant3/types/ActionLogEvents";
import logAction from "@/apps/merchant3/services/action-logs.service";
import { checkTranscribe } from "@/apps/merchant3/services/imageUpload.service";
import logEvent from "@/apps/merchant3/services/event-logs.service";
import EventLogs from "@/apps/merchant3/types/EventLogs";
import { IVuexState } from "@/apps/merchant3/shared-models/IVuex";
import { Store } from "vuex";
import { IncodeStep } from "@/apps/merchant3/types/IncodeStep";

export default function useIncodeOnBoardStatus(
  incodeStep: string = IncodeStep.DEFAULT
): void {
  const vuexStore = store as unknown as Store<IVuexState>;
  let started = false;
  let importStarted = false;
  // let isUserTranscribed = false;
  // let redirectPath = "";
  const getStatus =
    incodeStep === IncodeStep.FRONT ? incodeStatusFront : incodeStatus;

  const interval: number = setInterval(() => {
    if (vuexStore.state.carts?.cartTag) {
      getStatus(vuexStore.state.carts?.cartTag)
        .then((response: AxiosResponse<IIncodeStatus>) => {
          if (!started) {
            logEvent(EventLogs.Events.INCODE_STATUS, {
              completed: false,
              time: Date.now(),
            });

            logAction(ActionLogs.Events.INCODE_STATUS, {
              completed: false,
              time: Date.now(),
            });

            started = true;
          }
          store.dispatch("carts/setIncodeOnBoardStatus", response.data.status);
          if (response.data.completed) {
            logEvent(EventLogs.Events.INCODE_STATUS, {
              completed: true,
              time: Date.now(),
            });
            logAction(ActionLogs.Events.INCODE_STATUS, {
              completed: true,
              time: Date.now(),
            });

            startImport(vuexStore.state.carts?.cartTag as string);
            clearInterval(interval);
          }
        })
        .catch((error: AxiosError) => {
          logEvent(EventLogs.Events.INCODE_STATUS, {
            completed: false,
            time: Date.now(),
            error: error.message,
          });
          logAction(ActionLogs.Events.INCODE_STATUS, {
            completed: false,
            time: Date.now(),
            error: error.message,
          });
        });
    }
  }, 5000);

  const startImport = (cartTag: string) => {
    if (!importStarted) {
      importStarted = true;

      logEvent(EventLogs.Events.INCODE_IMPORT_STARTED, {
        time: Date.now(),
      });

      logAction(ActionLogs.Events.INCODE_START_IMPORT, {
        time: Date.now(),
      });

      incodeImport(cartTag).then((response: AxiosResponse<IIncodeImport>) => {
        console.log(response);
        if (response.data?.completed === true) {
          try {
            checkTranscribe(cartTag, 3).finally(() => {
              store.dispatch(
                "carts/setIncodeOnBoardCompleted",
                response.data.completed
              );
              logEvent(EventLogs.Events.INCODE_IMPORT_FINISHED, {
                time: Date.now(),
              });
              logAction(ActionLogs.Events.INCODE_FINISHED_IMPORT, {
                time: Date.now(),
              });
            });
          } catch (error) {
            console.error("Error transcribing the nationalID");
          }
        } else {
          importStarted = false;
          startImport(cartTag);
        }
      });
    }
  };

  onUnmounted(() => {
    clearInterval(interval);
  });
}
